import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCounts } from "../../../store/slices/Dashboard/getDashboardSlice";

import { currentTabHandler } from "../../../store/slices/Project/ProjectSlice";
import Preference from "../Preference";

const useDashboardCount = () => {
  const dispatch = useDispatch();

  const {
    activeProjectCount,
    completedProjectCount,
    permanentStaffCount,
    contractStaffCount,
  } = useSelector((state) => state.dashborad.allCount);
  const { allCount } = useSelector((state) => state.dashborad);

  const { userProfileData, status } = useSelector((state) => state.userData);
  const [selectedKeys] = useState([
    "email",
    "logo",
    "mobile",
    "profile_photo_url",
    "water_mark",
  ]);

  const [percentage, setPercentage] = useState(0);

  let projectstatus = [
    {
      title: "Active projects",
      value: activeProjectCount,
      link: "project",
      tab: "activeTab",
      type: "active_projects",
    },
    {
      title: "Completed projects",
      value: completedProjectCount,
      link: "project",
      tab: "completedTab",
      type: "completed_projects",
    },
    {
      title: "Permanent staff",
      value: permanentStaffCount,
      link: "/dashboard/staffs/permanant",
      type: "permanent_staff",
    },
    {
      title: "Contract staff",
      value: contractStaffCount,
      link: "/dashboard/staffs/contract",
      type: "contract_staff",
    },
  ];

  useEffect(() => {
    if (Object.keys(allCount).length === 0) {
      handleGetCounts();
    }
  }, []);
  useEffect(() => {
    const calculatePercentage = () => {
      const social_media = userProfileData?.preference?.social_media?.map(
        (item) => item.link
      );
      const totalSelectedKeys =
        selectedKeys.length + (social_media ? social_media.length : 0);
      let keysWithValue = 0;

      selectedKeys.forEach((key) => {
        if (userProfileData[key]) {
          keysWithValue++;
        }
      });

      let socialMedia = 0;

      for (let i = 0; i < social_media?.length; i++) {
        if (social_media[i] !== null) {
          socialMedia++;
        }
      }
      const percentage =
        ((keysWithValue + socialMedia) / totalSelectedKeys) * 100;
      return percentage;
    };

    const result = calculatePercentage();
    setPercentage(result);
  }, [userProfileData, selectedKeys]);
  const handleGetCounts = () => {
    dispatch(getCounts());
  };

  const handleSetCurrentTabForProject = (tab) => {
    dispatch(currentTabHandler(tab));
  };

  return {
    handleGetCounts,
    activeProjectCount,
    completedProjectCount,
    permanentStaffCount,
    contractStaffCount,
    projectstatus,
    handleSetCurrentTabForProject,
    percentage,
  };
};

export default useDashboardCount;
